var _path, _path2, _path3, _path4, _rect, _path5, _path6, _path7, _path8, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraPermission(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 145,
    viewBox: "0 0 136 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1589 117.245L24.194 117.169C21.035 116.98 19.2924 113.086 21.4553 110.643C27.1301 104.232 30.6274 95.8648 30.7967 86.6731C30.7931 86.4402 30.7913 86.2068 30.7913 85.973C30.7913 85.7393 30.7931 85.5061 30.7967 85.2732C30.5439 71.5655 22.8816 59.6702 11.6372 53.4051C9.72676 52.3407 9.04781 49.9413 10.1207 48.0459C15.8894 37.8546 118.254 37.9908 123.946 48.0457C125.018 49.9411 124.339 52.3405 122.429 53.4049C119.095 55.2627 116.076 57.6154 113.471 60.3636C113.284 60.6563 113.054 60.9291 112.782 61.173C112.712 61.2363 112.64 61.2965 112.566 61.3538C106.912 67.7636 103.431 76.1279 103.269 85.3026C103.272 85.5258 103.274 85.7494 103.274 85.9733C103.274 86.1972 103.272 86.4208 103.269 86.644C103.432 95.8459 106.929 104.224 112.609 110.64C114.709 113.013 113.131 116.81 110.073 117.149L110.115 117.245C81.4537 117.245 52.8205 117.245 24.1589 117.245Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.527 109.356L24.1325 109.357C22.5731 109.357 21.1588 110.272 20.52 111.695C19.8811 113.117 20.1367 114.782 21.1727 115.948C30.4838 126.423 47.7326 133 66.8544 133C85.9507 133 103.163 126.386 112.48 115.955C113.52 114.79 113.779 113.124 113.142 111.699C112.504 110.274 111.088 109.356 109.527 109.356Z",
    fill: "#28D859"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.242 5C62.0549 5 60.2819 6.77299 60.2819 8.96009V25.0926C46.0981 19.6667 30.3697 24.7608 19.7003 35.2007C16.5627 38.2708 14.1807 41.341 12.5809 43.6435C11.6856 44.9319 10.8179 46.2441 10.0779 47.6292C9.45534 48.798 9.45914 50.3368 10.1767 51.5319C10.8925 52.7241 12.1812 53.4535 13.5718 53.4535H120.494C121.885 53.4535 123.173 52.7241 123.889 51.5319C125.545 48.774 123.006 45.799 121.485 43.6435C119.885 41.341 117.503 38.2708 114.366 35.2007C103.707 24.7709 87.9639 19.6682 73.7842 25.0926V8.96009C73.7842 6.77299 72.0112 5 69.8241 5H64.242Z",
    fill: "#28D859"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9732 31.8282C72.9732 35.4733 70.0183 38.4283 66.3731 38.4283C62.7279 38.4283 59.7729 35.4733 59.7729 31.8282C59.7729 28.183 62.7279 25.228 66.3731 25.228C70.0183 25.228 72.9732 28.183 72.9732 31.8282Z",
    fill: "#28D859"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 73,
    width: 118,
    height: 18,
    rx: 9,
    fill: "#00F0FF",
    fillOpacity: 0.62
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7426 6.12231H18C11.3726 6.12231 6 11.4949 6 18.1223V22.8649",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M130 22.8649L130 18.1223C130 11.4949 124.627 6.12231 118 6.12231L113.257 6.12231",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M113.257 138.494L118 138.494C124.627 138.494 130 133.121 130 126.494L130 121.751",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6 121.751L6 126.494C6 133.121 11.3726 138.494 18 138.494L22.7426 138.494",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 9.61182,
    y1: 81.6772,
    x2: 124.454,
    y2: 81.6772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BBD53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#338984"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraPermission);
export default __webpack_public_path__ + "static/media/camera_permission.d0bc2800.svg";
export { ForwardRef as ReactComponent };